// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1xcr0","rootMobile":"styles_rootMobile__1LJ79"};